import { Injectable } from "@angular/core";
import { ShipmentPackageTYpe } from "../constants/constants";

@Injectable({
    providedIn: "root",
})
export class SoShipmentService {
    constructor() {}

    /*** EasyPost shipment */
    onSuccessEasyPostShipmentPrepareInvoiceData(reqData, e, freeShipObj, app) {
        const shipment = [];
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            let shippingCost = e?.shippingCost || 0;
            if (e?.codCharge) {
                shippingCost = Number(shippingCost) + Number(e?.codCharge);
            }
            let insuranceFee = 0;
            if (e?.label?.fees && e?.label?.fees?.length) {
                const fee = e.label.fees.filter((f) => f.type.toLowerCase() == "insurancefee")[0];
                insuranceFee = fee && fee?.amount ? Number(fee?.amount) : 0;
            }
            
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge); // shipping chnanges stg2
            // reqData.shippingCharge = Number(reqData.shippingCharge) + Number(shippingCost) + insuranceFee; // shipping chnanges stg2
            reqData.shippingCharge = Number(shippingCost) + insuranceFee; // shipping chnanges stg2
            
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost) + insuranceFee;
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost) + insuranceFee;
            const obj = {
                id: 0,
                invoiceId: reqData?.id,
                trackingNo: e?.label?.tracking_code ? e?.label?.tracking_code : "",
                trackingLink: e?.label?.tracker?.public_url ? e?.label?.tracker?.public_url : "",
                labelLink: e?.label?.postage_label?.label_url ? e?.label?.postage_label?.label_url : "",
                shipmentId: e?.label?.tracker?.shipment_id ? e?.label?.tracker?.shipment_id : "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "", // ups does not provide label link
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost) + insuranceFee,
                accountNumber: e?.accountNo || "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge) + Number(e.label?.shipments[0]?.selected_rate?.rate);
            // reqData.shippingCharge = Number(reqData.shippingCharge) + Number(e.label?.shipments[0]?.selected_rate?.rate);
            reqData.shippingCharge = Number(e.label?.shipments[0]?.selected_rate?.rate);
            e.label.shipments.forEach((element) => {
                const obj = {
                    id: 0,
                    invoiceId: reqData?.id,
                    trackingNo: element?.tracking_code ? element?.tracking_code : "",
                    trackingLink: element?.tracker?.public_url ? element?.tracker?.public_url : "",
                    labelLink: element?.postage_label?.label_url ? element?.postage_label?.label_url : "",
                    shipmentId: element?.id ? element?.id : "",
                    weight: e?.formValue?.weight ? Number(e?.formValue?.weight) : 0,
                    uomName: e?.formValue?.mass?.name ? e?.formValue?.mass?.name : "",
                    uomId: 0, // todo
                    shippingMethodId: e?.selectedCarrier?.id || 0,
                    shipmentCost: Number(e.label?.selected_rate?.rate),
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        reqData.invoiceShipment = shipment;
        reqData.shippingFinancialId = reqData?.shippingMethod?.financialAccountId || 0;
        // free shipping
        reqData.isFreeShipping = e.isFreeShipping ? true : false;
        reqData.freeShippingDiscountName = e.isFreeShipping ? freeShipObj?.name : "";
        reqData.freeShippingDiscountAccountId = e.isFreeShipping ? freeShipObj?.incomeAccount : 0;
        reqData.freeShippingDiscountId = e.isFreeShipping ? freeShipObj?.id : 0;
        if (e.isFreeShipping) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge);
        }
        reqData.invoiceNotes = this.getInvoiceNote(reqData, app);
        reqData.invoiceAudits = this.getInvoiceAudit(reqData, app);
        reqData.businessName = reqData?.account?.businessName;
        reqData.account = null;
        reqData.billingAddress = null;
        reqData.shippingAddress = null;
        reqData.warehouse = null;
        reqData.user = null;
        reqData.paymentMethod = null;
        reqData.paymentTerm = null;
        reqData.discountType = null;
        reqData.tax = null;
        reqData.shippingMethod = null;
        reqData.shippingTerm = null;
        reqData.invoiceStatus = null;
        reqData.contact = null;
        reqData.shipContact = null;
        if (reqData.invoiceProducts && reqData.invoiceProducts.length) {
            reqData.invoiceProducts.forEach((e) => {
                e.product = null;
                if (e.invoiceBundleDetail && e.invoiceBundleDetail.length) {
                    e.invoiceBundleDetail.forEach((b) => {
                        b.product = null;
                    });
                }
            });
        }
        return reqData;
    }
    onSuccessEasyPostShipmentPrepareSalesOrderData(reqData, e, freeShipObj, app) {
        const shipment = [];
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            let shippingCost = e?.shippingCost || 0;
            if (e?.codCharge) {
                shippingCost = Number(shippingCost) + Number(e?.codCharge);
            }
            let insuranceFee = 0;
            if (e?.label?.fees && e?.label?.fees?.length) {
                const fee = e.label.fees.filter((f) => f.type.toLowerCase() == "insurancefee")[0];
                insuranceFee = fee && fee?.amount ? Number(fee?.amount) : 0;
            }
            reqData.shippingChargeAmount = Number(reqData.shippingChargeAmount) + Number(shippingCost) + insuranceFee;
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost) + insuranceFee;
            const obj = {
                id: 0,
                salesOrderId: reqData?.id,
                trackingNo: e?.label?.tracking_code ? e?.label?.tracking_code : "",
                trackingLink: e?.label?.tracker?.public_url ? e?.label?.tracker?.public_url : "",
                labelLink: e?.label?.postage_label?.label_url ? e?.label?.postage_label?.label_url : "",
                shipmentId: e?.label?.tracker?.shipment_id ? e?.label?.tracker?.shipment_id : "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "", // ups does not provide label link
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost) + insuranceFee,
                accountNumber: e?.accountNo || "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingChargeAmount) + Number(e.label?.shipments[0]?.selected_rate?.rate);
            reqData.shippingChargeAmount = Number(reqData.shippingChargeAmount) + Number(e.label?.shipments[0]?.selected_rate?.rate);
            e.label.shipments.forEach((element) => {
                const obj = {
                    id: 0,
                    salesOrderId: reqData?.id,
                    trackingNo: element?.tracking_code ? element?.tracking_code : "",
                    trackingLink: element?.tracker?.public_url ? element?.tracker?.public_url : "",
                    labelLink: element?.postage_label?.label_url ? element?.postage_label?.label_url : "",
                    shipmentId: element?.id ? element?.id : "",
                    weight: e?.formValue?.weight ? Number(e?.formValue?.weight) : 0,
                    uomName: e?.formValue?.mass?.name ? e?.formValue?.mass?.name : "",
                    uomId: 0, // todo
                    shippingMethodId: e?.selectedCarrier?.id || 0,
                    shipmentCost: Number(e.label?.selected_rate?.rate),
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        reqData.shipment = shipment;
        reqData.salesOrderNote = this.getSONote(reqData, app);
        reqData.salesOrderAudit = this.getSOAudit(reqData, app);
        // reqData.salesOrderDate = app._saveDateTimeWithZone(reqData.salesOrderDate);
        // free shipping
        reqData.isFreeShipping = e.isFreeShipping ? true : false;
        reqData.freeShippingDiscountName = e.isFreeShipping ? freeShipObj?.name : "";
        reqData.freeShippingDiscountAccountId = e.isFreeShipping ? freeShipObj?.incomeAccount : 0;
        reqData.freeShippingDiscountId = e.isFreeShipping ? freeShipObj?.id : 0;
        if (e.isFreeShipping) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingChargeAmount);
        }
        reqData.account = null;
        reqData.warehouse = null;
        reqData.user = null;
        reqData.shippingAddress = null;
        reqData.discountType = null;
        reqData.paymentMethod = null;
        reqData.paymentTerm = null;
        reqData.shippingMethod = null;
        reqData.shippingTerm = null;
        reqData.contact = null;
        reqData.shipContact = null;
        if (reqData.salesOrderProducts && reqData.salesOrderProducts.length) {
            reqData.salesOrderProducts.forEach((e) => {
                e.product = null;
                if (e?.salesOrderBundleDetail && e?.salesOrderBundleDetail?.length > 0) {
                    e?.salesOrderBundleDetail?.forEach((b) => {
                        b.product = null;
                    });
                }
            });
        }
        return reqData;
    }
    onSuccessEasyPostShipmentPrepareRMAData(customerReturn, e, freeShipObj, app){
        const shipment = [];
        let shippingCost = e?.shippingCost || 0;
        if (e?.codCharge) {
            shippingCost = Number(shippingCost) + Number(e?.codCharge);
        }
        let insuranceFee = 0;
        if (e?.label?.fees && e?.label?.fees?.length) {
            const fee = e.label.fees.filter((f) => f.type.toLowerCase() == "insurancefee")[0];
            insuranceFee = fee && fee?.amount ? Number(fee?.amount) : 0;
        }
        customerReturn.returnLabelCharges = Number(shippingCost) + insuranceFee;
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            const obj = {
                id: 0,
                customerRMAId: customerReturn?.id,
                trackingNo: e?.label?.tracking_code ? e?.label?.tracking_code : "",
                trackingLink: e?.label?.tracker?.public_url ? e?.label?.tracker?.public_url : "",
                labelLink: e?.label?.postage_label?.label_url ? e?.label?.postage_label?.label_url : "",
                shipmentId: e?.label?.tracker?.shipment_id ? e?.label?.tracker?.shipment_id : "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                refundStatus: "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "",
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost) + insuranceFee,
                accountNumber: e?.accountNo || "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            e?.label?.shipments?.forEach((element) => {
                const obj = {
                    id: 0,
                    customerRMAId: customerReturn?.id,
                    trackingNo: element?.tracking_code ? element?.tracking_code : "",
                    trackingLink: element?.tracker?.public_url ? element?.tracker?.public_url : "",
                    labelLink: element?.postage_label?.label_url ? element?.postage_label?.label_url : "",
                    shipmentId: element?.id ? element?.id : "",
                    weight: e?.formValue?.weight ? Number(e?.formValue?.weight) : 0,
                    uomName: e?.formValue?.mass?.name ? e?.formValue?.mass?.name : "",
                    uomId: 0, // todo
                    shippingMethodId: e?.selectedCarrier?.id || 0,
                    shipmentCost: Number(e.label?.selected_rate?.rate),
                    accountNumber: e?.accountNo || "",
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    refundStatus: "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        customerReturn.rmaReturnShipment = shipment;
        customerReturn.account = null;
        customerReturn.address = null;
        customerReturn.invoice = null;
        customerReturn.warehouse = null;
        return customerReturn;
    }

    /*** FEDEX shipment */
    onSuccessFedexShipmentGetInvoiceObj(reqData, e, freeShipObj, app) {
        const shipment = [];
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            let shippingCost = e?.shippingCost || 0;
            if (e?.codCharge) {
                shippingCost = Number(shippingCost) + Number(e?.codCharge);
            }
            
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge);
            // reqData.shippingCharge = Number(reqData.shippingCharge) + Number(shippingCost);
            reqData.shippingCharge = Number(shippingCost);
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost);
            
            // if COD passed in reqDatauest body, merged label will be in shipment documents else label will be in pacakgedocuments.
            const label = e?.label?.output?.transactionShipments?.[0]?.shipmentDocuments?.[0]?.url ? e?.label?.output?.transactionShipments?.[0]?.shipmentDocuments?.[0]?.url : e?.label?.output?.transactionShipments?.[0]?.pieceResponses?.[0]?.packageDocuments?.[0]?.url ? e?.label?.output?.transactionShipments?.[0]?.pieceResponses?.[0]?.packageDocuments?.[0]?.url : "";
            let labelArr = [];
            if (label) {
                labelArr = label.split("&autoPrint"); // extra param in url, so file is not downloading
            }
            const obj = {
                id: 0,
                invoiceId: reqData?.id,
                trackingNo: e?.label?.output?.transactionShipments[0]?.masterTrackingNumber ? e?.label?.output?.transactionShipments[0]?.masterTrackingNumber : "",
                trackingLink: "FEDEX",
                labelLink: labelArr && labelArr.length ? labelArr[0] : "",
                shipmentId: e?.label?.output?.transactionShipments[0]?.masterTrackingNumber ? e?.label?.output?.transactionShipments[0]?.masterTrackingNumber : "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "", // ups does not provide label link
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost),
                accountNumber: e?.accountNo || "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge) + Number(e.label?.shipments[0]?.selected_rate?.rate);
            // reqData.shippingCharge = Number(reqData.shippingCharge) + Number(e.label?.shipments[0]?.selected_rate?.rate);
            reqData.shippingCharge = Number(e.label?.shipments[0]?.selected_rate?.rate);
            e.label.shipments.forEach((element) => {
                const obj = {
                    id: 0,
                    invoiceId: reqData?.id,
                    trackingNo: element?.tracking_code ? element?.tracking_code : "",
                    trackingLink: element?.tracker?.public_url ? element?.tracker?.public_url : "",
                    labelLink: element?.postage_label?.label_url ? element?.postage_label?.label_url : "",
                    shipmentId: element?.id ? element?.id : "",
                    shippingMethodId: e?.selectedCarrier?.id || 0, 
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        reqData.invoiceShipment = shipment;
        reqData.shippingFinancialId = reqData?.shippingMethod?.financialAccountId || 0;
        // free shipping
        reqData.isFreeShipping = e.isFreeShipping ? true : false;
        reqData.freeShippingDiscountName = e.isFreeShipping ? freeShipObj?.name : "";
        reqData.freeShippingDiscountAccountId = e.isFreeShipping ? freeShipObj?.incomeAccount : 0;
        reqData.freeShippingDiscountId = e.isFreeShipping ? freeShipObj?.id : 0;
        if (e.isFreeShipping) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge);
        }
        reqData.businessName = reqData?.account?.businessName;
        reqData.invoiceNotes = this.getInvoiceNote(reqData, app);
        reqData.invoiceAudits = this.getInvoiceAudit(reqData, app);
        reqData.account = null;
        reqData.billingAddress = null;
        reqData.shippingAddress = null;
        reqData.warehouse = null;
        reqData.user = null;
        reqData.paymentMethod = null;
        reqData.paymentTerm = null;
        reqData.discountType = null;
        reqData.tax = null;
        reqData.shippingMethod = null;
        reqData.shippingTerm = null;
        reqData.invoiceStatus = null;
        reqData.contact = null;
        reqData.shipContact = null;
        if (reqData.invoiceProducts && reqData.invoiceProducts.length) {
            reqData.invoiceProducts.forEach((e) => {
                e.product = null;
                if (e.invoiceBundleDetail && e.invoiceBundleDetail.length) {
                    e.invoiceBundleDetail.forEach((b) => {
                        b.product = null;
                    });
                }
            });
        }
        return reqData;
    }
    onSuccessFedexShipmentGetSOObj(reqData, e, freeShipObj, app) {
        const shipment = [];
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            let shippingCost = e?.shippingCost || 0;
            if (e?.codCharge) {
                shippingCost = Number(shippingCost) + Number(e?.codCharge);
            }
            reqData.shippingChargeAmount = Number(reqData.shippingChargeAmount) + Number(shippingCost);
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost);
            // if COD passed in request body, merged label will be in shipment documents else label will be in pacakgedocuments.
            const label = e?.label?.output?.transactionShipments?.[0]?.shipmentDocuments?.[0]?.url ? e?.label?.output?.transactionShipments?.[0]?.shipmentDocuments?.[0]?.url : e?.label?.output?.transactionShipments?.[0]?.pieceResponses?.[0]?.packageDocuments?.[0]?.url ? e?.label?.output?.transactionShipments?.[0]?.pieceResponses?.[0]?.packageDocuments?.[0]?.url : "";
            let labelArr = [];
            if (label) {
                labelArr = label.split("&autoPrint"); // extra param in url, so file is not downloading
            }
            const obj = {
                id: 0,
                salesOrderId: reqData?.id,
                trackingNo: e?.label?.output?.transactionShipments[0]?.masterTrackingNumber ? e?.label?.output?.transactionShipments[0]?.masterTrackingNumber : "",
                trackingLink: "FEDEX",
                labelLink: labelArr && labelArr.length ? labelArr[0] : "",
                shipmentId: e?.label?.output?.transactionShipments[0]?.masterTrackingNumber ? e?.label?.output?.transactionShipments[0]?.masterTrackingNumber : "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "",
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost),
                accountNumber: e?.accountNo || "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingChargeAmount) + Number(e.label?.shipments[0]?.selected_rate?.rate);
            if (e.label?.shipments[0]?.options && e.label?.shipments[0]?.options.cod_amount) {
                reqData.netAmount += Number(e.label?.shipments[0]?.options.cod_amount);
                reqData.shippingChargeAmount = Number(e.label?.shipments[0]?.selected_rate?.rate) + Number(e.label?.shipments[0]?.options.cod_amount);
            } else {
                reqData.shippingChargeAmount = Number(e.label?.shipments[0]?.selected_rate?.rate);
            }
            e.label.shipments.forEach((element) => {
                const obj = {
                    id: 0,
                    salesOrderId: reqData?.id,
                    trackingNo: element?.tracking_code ? element?.tracking_code : "",
                    trackingLink: element?.tracker?.public_url ? element?.tracker?.public_url : "",
                    labelLink: element?.postage_label?.label_url ? element?.postage_label?.label_url : "",
                    shipmentId: element?.id ? element?.id : "",
                    shippingMethodId: e?.selectedCarrier?.id || 0,
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        reqData.shipment = shipment;
        reqData.salesOrderNote = this.getSONote(reqData, app);
        reqData.salesOrderAudit = this.getSOAudit(reqData, app);
        // reqData.salesOrderDate = app._saveDateTimeWithZone(reqData.salesOrderDate);
        // free shipping
        reqData.isFreeShipping = e.isFreeShipping ? true : false;
        reqData.freeShippingDiscountName = e.isFreeShipping ? freeShipObj?.name : "";
        reqData.freeShippingDiscountAccountId = e.isFreeShipping ? freeShipObj?.incomeAccount : 0;
        reqData.freeShippingDiscountId = e.isFreeShipping ? freeShipObj?.id : 0;
        if (e.isFreeShipping) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingChargeAmount);
        }
        reqData.account = null;
        reqData.warehouse = null;
        reqData.user = null;
        reqData.shippingAddress = null;
        reqData.discountType = null;
        reqData.paymentMethod = null;
        reqData.paymentTerm = null;
        reqData.shippingMethod = null;
        reqData.shippingTerm = null;
        reqData.contact = null;
        reqData.shipContact = null;
        if (reqData.salesOrderProducts && reqData.salesOrderProducts.length) {
            reqData.salesOrderProducts.forEach((e) => {
                e.product = null;
                if (e?.salesOrderBundleDetail && e?.salesOrderBundleDetail?.length) {
                    e?.salesOrderBundleDetail?.forEach((b) => {
                        b.product = null;
                        // if(b.childSalesOrderBundleDetail && b.childSalesOrderBundleDetail.length > 0){
                        //     b.childSalesOrderBundleDetail.forEach((c) => {
                        //         c.product = null;
                        //     });
                        // }
                    });
                }
            });
        }
        return reqData;
    }
    onSuccessFedexShipmentPrepareCustomerReturnData(customerReturn: any, e, freeShipObj, app){
        const shipment = [];
        let shippingCost = e?.shippingCost || 0;
        if (e?.codCharge) {
            shippingCost = Number(shippingCost) + Number(e?.codCharge);
        }
        customerReturn.returnLabelCharges = Number(shippingCost);
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            // if COD passed in reqDatauest body, merged label will be in shipment documents else label will be in pacakgedocuments.
            const label = e?.label?.output?.transactionShipments?.[0]?.shipmentDocuments?.[0]?.url ? e?.label?.output?.transactionShipments?.[0]?.shipmentDocuments?.[0]?.url : e?.label?.output?.transactionShipments?.[0]?.pieceResponses?.[0]?.packageDocuments?.[0]?.url ? e?.label?.output?.transactionShipments?.[0]?.pieceResponses?.[0]?.packageDocuments?.[0]?.url : "";
            let labelArr = [];
            if (label) {
                labelArr = label.split("&autoPrint"); // extra param in url, so file is not downloading
            }
            const obj = {
                id: 0,
                customerRMAId: customerReturn?.id,
                trackingNo: e?.label?.output?.transactionShipments[0]?.masterTrackingNumber ? e?.label?.output?.transactionShipments[0]?.masterTrackingNumber : "",
                trackingLink: "FEDEX",
                labelLink: labelArr && labelArr.length ? labelArr[0] : "",
                shipmentId: e?.label?.output?.transactionShipments[0]?.masterTrackingNumber ? e?.label?.output?.transactionShipments[0]?.masterTrackingNumber : "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                refundStatus: "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "",
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost),
                accountNumber: e?.accountNo || "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            e?.label?.shipments?.forEach((element) => {
                const obj = {
                    id: 0,
                    customerRMAId: customerReturn?.id,
                    trackingNo: element?.tracking_code ? element?.tracking_code : "",
                    trackingLink: element?.tracker?.public_url ? element?.tracker?.public_url : "",
                    labelLink: element?.postage_label?.label_url ? element?.postage_label?.label_url : "",
                    shipmentId: element?.id ? element?.id : "",
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    refundStatus: "",
                    weight: e?.formValue?.weight ? Number(e?.formValue?.weight) : 0,
                    uomName: e?.formValue?.mass?.name ? e?.formValue?.mass?.name : "",
                    uomId: 0, // todo
                    shippingMethodId: e?.selectedCarrier?.id || 0,
                    shipmentCost: Number(shippingCost),
                    accountNumber: e?.accountNo || "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        customerReturn.rmaReturnShipment = shipment;
        customerReturn.account = null;
        customerReturn.address = null;
        customerReturn.invoice = null;
        customerReturn.warehouse = null;
        return customerReturn;
    }

    /*** UPS shipment */
    onSuccessUpsShipmentGetInvoiceObj(reqData, e, freeShipObj, app) {
        const shipment = [];
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            let shippingCost = e?.shippingCost || 0;
            if (e?.codCharge) {
                shippingCost = Number(shippingCost) + Number(e?.codCharge);
            }
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge); // shipping chnanges stg2
            // reqData.shippingCharge = Number(reqData.shippingCharge) + Number(shippingCost); // shipping chnanges stg2
            reqData.shippingCharge = Number(shippingCost);
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost);
            const obj = {
                id: 0,
                invoiceId: reqData?.id,
                trackingNo: e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber || "",
                trackingLink: "UPS",
                labelLink: "",
                shipmentId: e?.label?.ShipmentResponse?.ShipmentResults?.ShipmentIdentificationNumber || "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "", // ups does not provide label link
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost),
                accountNumber: e?.accountNo || "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            let shippingCost = e?.shippingCost || 0;
            if (e?.codCharge) {
                shippingCost = Number(shippingCost) + Number(e?.codCharge);
            }
            
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge);
            // reqData.shippingCharge = Number(reqData.shippingCharge) + Number(shippingCost);
            reqData.shippingCharge = Number(shippingCost);
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost);
            
            e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults.forEach((element) => {
                const obj = {
                    id: 0,
                    invoiceId: reqData?.id,
                    trackingNo: element?.TrackingNumber || "",
                    trackingLink: "UPS",
                    labelLink: "",
                    shipmentId: e?.label?.ShipmentResponse?.ShipmentResults?.ShipmentIdentificationNumber || "",
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    weight: e?.formValue?.weight ? Number(e?.formValue?.weight) : 0,
                    uomName: e?.formValue?.mass?.name ? e?.formValue?.mass?.name : "",
                    uomId: 0, // todo
                    shippingMethodId: e?.selectedCarrier?.id || 0,
                    shipmentCost: Number(shippingCost),
                    accountNumber: e?.accountNo || "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        reqData.invoiceShipment = shipment;
        reqData.shippingFinancialId = reqData?.shippingMethod?.financialAccountId || 0;
        // free shipping
        reqData.isFreeShipping = e.isFreeShipping ? true : false;
        reqData.freeShippingDiscountName = e.isFreeShipping ? freeShipObj?.name : "";
        reqData.freeShippingDiscountAccountId = e.isFreeShipping ? freeShipObj?.incomeAccount : 0;
        reqData.freeShippingDiscountId = e.isFreeShipping ? freeShipObj?.id : 0;
        if (e.isFreeShipping) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingCharge);
        }
        reqData.businessName = reqData?.account?.businessName;
        reqData.invoiceNotes = this.getInvoiceNote(reqData, app);
        reqData.invoiceAudits = this.getInvoiceAudit(reqData, app);
        reqData.account = null;
        reqData.billingAddress = null;
        reqData.shippingAddress = null;
        reqData.warehouse = null;
        reqData.user = null;
        reqData.paymentMethod = null;
        reqData.paymentTerm = null;
        reqData.discountType = null;
        reqData.tax = null;
        reqData.shippingMethod = null;
        reqData.shippingTerm = null;
        reqData.invoiceStatus = null;
        reqData.contact = null;
        reqData.shipContact = null;
        if (reqData.invoiceProducts && reqData.invoiceProducts.length) {
            reqData.invoiceProducts.forEach((e) => {
                e.product = null;
                if (e.invoiceBundleDetail && e.invoiceBundleDetail.length) {
                    e.invoiceBundleDetail.forEach((b) => {
                        b.product = null;
                    });
                }
            });
        }
        return reqData;
    }
    onSuccessUpsShipmentGetSOObj(reqData, e, freeShipObj, app) {
        // debugger;
        // console.log(reqData);
        const shipment = [];
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            let shippingCost = e?.shippingCost || 0;
            if (e?.codCharge) {
                shippingCost = Number(shippingCost) + Number(e?.codCharge);
            }
            reqData.shippingChargeAmount = Number(reqData.shippingChargeAmount) + Number(shippingCost);
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost);
            const obj = {
                id: 0,
                salesOrderId: reqData?.id,
                trackingNo: e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber || "",
                trackingLink: "UPS",
                labelLink: "", // ups does not provide label link
                shipmentId: e?.label?.ShipmentResponse?.ShipmentResults?.ShipmentIdentificationNumber || "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "", // ups does not provide label link
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost),
                accountNumber: e?.accountNo || "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            let shippingCost = e?.shippingCost || 0;
            if (e?.codCharge) {
                shippingCost = Number(shippingCost) + Number(e?.codCharge);
            }
            reqData.shippingChargeAmount = Number(reqData.shippingChargeAmount) + Number(shippingCost);
            reqData.netAmount = Number(reqData.netAmount) + Number(shippingCost);
            e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults.forEach((element) => {
                const obj = {
                    id: 0,
                    salesOrderId: reqData?.id,
                    trackingNo: element?.TrackingNumber || "",
                    trackingLink: "UPS",
                    labelLink: "", // ups does not provide label link
                    shipmentId: e?.label?.ShipmentResponse?.ShipmentResults?.ShipmentIdentificationNumber || "",
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    weight: e?.formValue?.weight ? Number(e?.formValue?.weight) : 0,
                    uomName: e?.formValue?.mass?.name ? e?.formValue?.mass?.name : "",
                    uomId: 0, // todo
                    shippingMethodId: e?.selectedCarrier?.id || 0,
                    shipmentCost: Number(shippingCost),
                    accountNumber: e?.accountNo || "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        reqData.shipment = shipment;
        reqData.salesOrderNote = this.getSONote(reqData, app);
        reqData.salesOrderAudit = this.getSOAudit(reqData, app);
        // reqData.salesOrderDate = app._saveDateTimeWithZone(reqData.salesOrderDate);
        // free shipping
        reqData.isFreeShipping = e.isFreeShipping ? true : false;
        reqData.freeShippingDiscountName = e.isFreeShipping ? freeShipObj?.name : "";
        reqData.freeShippingDiscountAccountId = e.isFreeShipping ? freeShipObj?.incomeAccount : 0;
        reqData.freeShippingDiscountId = e.isFreeShipping ? freeShipObj?.id : 0;
        if (e.isFreeShipping) {
            reqData.netAmount = Number(reqData.netAmount) - Number(reqData.shippingChargeAmount);
        }
        reqData.account = null;
        reqData.warehouse = null;
        reqData.user = null;
        reqData.shippingAddress = null;
        reqData.discountType = null;
        reqData.paymentMethod = null;
        reqData.paymentTerm = null;
        reqData.shippingMethod = null;
        reqData.shippingTerm = null;
        reqData.contact = null;
        reqData.shipContact = null;
        if (reqData.salesOrderProducts && reqData.salesOrderProducts.length) {
            reqData.salesOrderProducts.forEach((e) => {
                e.product = null;
                if (e?.salesOrderBundleDetail && e?.salesOrderBundleDetail?.length) {
                    e?.salesOrderBundleDetail?.forEach((b) => {
                        b.product = null;
                    });
                }
            });
        }
        return reqData;
    }
    onSuccessUpsShipmentPrepareCustomerReturnData(customerReturn: any, e, freeShipObj, app){
        const shipment = [];
        let shippingCost = e?.shippingCost || 0;
        if (e?.codCharge) {
            shippingCost = Number(shippingCost) + Number(e?.codCharge);
        }
        customerReturn.returnLabelCharges = Number(shippingCost);
        
        if (e.type == ShipmentPackageTYpe.SinglePack) {
            const obj = {
                id: 0,
                customerRMAId: customerReturn?.id,
                trackingNo: e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults?.TrackingNumber || "",
                trackingLink: "UPS",
                labelLink: "",
                shipmentId: e?.label?.ShipmentResponse?.ShipmentResults?.ShipmentIdentificationNumber || "",
                statusId: 1,
                shipmentMessage: "",
                deliveryStatus: "",
                refundStatus: "",
                height: Number(e.height),
                weight: Number(e?.weight),
                length: Number(e.length),
                width: Number(e.width),
                LWHUOMId: e.uomId,
                LWHUOMName: e.uomName,
                zipCode: e.zipCode,
                addressTypeId: e.addressTypeId,
                LabelDownloadLink: "", // ups does not provide label link
                uomName: e.uomName,
                uomId: e.uomId,
                shippingMethodId: e?.selectedCarrier?.id || 0,
                shipmentCost: Number(shippingCost),
                accountNumber: e?.accountNo || "",
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.user.userId,
                updatedBy: app.user.userId,
                createdDate: app._saveDateTimeWithZone(new Date()),
                updatedDate: app._saveDateTimeWithZone(new Date()),
                serviceName: e?.serviceName ?? "",
                serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
            };
            shipment.push(obj);
        } else if (e.type == ShipmentPackageTYpe.MultiPack) {
            e?.label?.ShipmentResponse?.ShipmentResults?.PackageResults.forEach((element) => {
                const obj = {
                    id: 0,
                    customerRMAId: customerReturn?.id,
                    trackingNo: element?.TrackingNumber || "",
                    trackingLink: "UPS",
                    labelLink: "",
                    shipmentId: e?.label?.ShipmentResponse?.ShipmentResults?.ShipmentIdentificationNumber || "",
                    statusId: 1,
                    shipmentMessage: "",
                    deliveryStatus: "",
                    refundStatus: "",
                    weight: e?.formValue?.weight ? Number(e?.formValue?.weight) : 0,
                    uomName: e?.formValue?.mass?.name ? e?.formValue?.mass?.name : "",
                    uomId: 0, // todo
                    shippingMethodId: e?.selectedCarrier?.id || 0,
                    shipmentCost: Number(shippingCost),
                    accountNumber: e?.accountNo || "",
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    serviceName: e?.serviceName ?? "",
                    serviceMethodTypeId: e?.serviceMethodTypeId ?? 0,
                };
                shipment.push(obj);
            });
        }
        customerReturn.rmaReturnShipment = shipment;
        customerReturn.account = null;
        customerReturn.address = null;
        customerReturn.invoice = null;
        customerReturn.warehouse = null;
        return customerReturn;
    }

    /**
     * Sales Order Audit and Note
     */
    getSONote(salesOrderDetails, app) {
        let note = null;
        if (salesOrderDetails.salesOrderNote && salesOrderDetails.salesOrderNote.length) {
            note = [
                {
                    id: 0,
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    salesOrderId: 0,
                    salesOrder: null,
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: app.userIP,
                        updatedSource: app.userIP,
                        createdBy: app.user.userId,
                        updatedBy: app.user.userId,
                        createdDate: app._saveDateTimeWithZone(new Date()),
                        updatedDate: app._saveDateTimeWithZone(new Date()),
                        comment: salesOrderDetails.salesOrderNote && salesOrderDetails.salesOrderNote.length ? salesOrderDetails.salesOrderNote[salesOrderDetails.salesOrderNote.length - 1].note.comment : "",
                        isImportant: true,
                        organizationId: app.companyId,
                        description: "",
                        statusId: 1,
                        status: null,
                        isValid: true,
                        validFromDate: new Date().toISOString(),
                        validToDate: new Date().toISOString(),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: "",
                    },
                },
            ];
        }
        return note;
    }
    getSOAudit(salesOrderDetails, app) {
        let audit = null;
        if (salesOrderDetails.salesOrderAudit && salesOrderDetails.salesOrderAudit.length) {
            audit = [
                {
                    id: 0,
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    salesOrderId: 0,
                    salesOrder: null,
                    userId: app.user.userId,
                    user: null,
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: app.userIP,
                        updatedSource: app.userIP,
                        createdBy: app.user.userId,
                        updatedBy: app.user.userId,
                        createdDate: app._saveDateTimeWithZone(new Date()),
                        updatedDate: app._saveDateTimeWithZone(new Date()),
                        comment: salesOrderDetails.salesOrderAudit && salesOrderDetails.salesOrderAudit.length ? salesOrderDetails.salesOrderAudit[salesOrderDetails.salesOrderAudit.length - 1].note.comment : "",
                        isImportant: true,
                        organizationId: app.companyId,
                        description: "",
                        statusId: 1,
                        status: null,
                        isValid: true,
                        validFromDate: new Date().toISOString(),
                        validToDate: new Date().toISOString(),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: "",
                    },
                    salesOrderStageId: salesOrderDetails.salesOrderStageId,
                    salesOrderStage: salesOrderDetails.salesOrderStage,
                    salesOrderStatusId: salesOrderDetails.salesOrderStatusId,
                    salesOrderStatus: salesOrderDetails.salesOrderStatus,
                },
            ];
        }
        return audit;
    }

    /**
     * Invoice Audit and Note
     */
    getInvoiceAudit(invDetails, app) {
        let invoiceAudits;
        if (invDetails.invoiceAudits && invDetails.invoiceAudits.length) {
            invoiceAudits = [
                {
                    id: 0,
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    invoiceId: 0,
                    description: "",
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: app.userIP,
                        updatedSource: app.userIP,
                        createdBy: app.user.userId,
                        updatedBy: app.user.userId,
                        createdDate: app._saveDateTimeWithZone(new Date()),
                        updatedDate: app._saveDateTimeWithZone(new Date()),
                        comment: invDetails.invoiceAudits && invDetails.invoiceAudits.length ? invDetails.invoiceAudits[invDetails.invoiceAudits.length - 1].note.comment : "",
                        isImportant: true,
                        organizationId: app.companyId,
                        description: "",
                        statusId: 1,
                        status: null,
                        isValid: true,
                        validFromDate: new Date().toISOString(),
                        validToDate: new Date().toISOString(),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: "",
                    },
                },
            ];
        }
        return invoiceAudits;
    }
    getInvoiceNote(invDetails, app) {
        let invoiceNotes;
        if (invDetails.invoiceNotes && invDetails.invoiceNotes.length) {
            invoiceNotes = [
                {
                    id: 0,
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.user.userId,
                    updatedBy: app.user.userId,
                    createdDate: app._saveDateTimeWithZone(new Date()),
                    updatedDate: app._saveDateTimeWithZone(new Date()),
                    invoiceId: 0,
                    userId: app.user.userId,
                    user: null,
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: app.userIP,
                        updatedSource: app.userIP,
                        createdBy: app.user.userId,
                        updatedBy: app.user.userId,
                        createdDate: app._saveDateTimeWithZone(new Date()),
                        updatedDate: app._saveDateTimeWithZone(new Date()),
                        comment: invDetails.invoiceNotes && invDetails.invoiceNotes.length ? invDetails.invoiceNotes[invDetails.invoiceNotes.length - 1].note.comment : "",
                        isImportant: true,
                        organizationId: app.companyId,
                        description: "",
                        statusId: 1,
                        status: null,
                        isValid: true,
                        validFromDate: new Date().toISOString(),
                        validToDate: new Date().toISOString(),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: null,
                    },
                    invoiceStatusId: invDetails.invoiceStatusId,
                    invoiceStatus: invDetails.invoiceStatus,
                },
            ];
        }
        return invoiceNotes;
    }

    /**
     * Preparing Invoice Shipment obj
     * when Invoice is created from Sales Order
     */
    prepareSalesOrderToInvoiceShipmentObj(soShipments) {
        let shipment = [];
        soShipments?.forEach((soShipment) => {
            const obj = {
                ...soShipment,
                id: 0,
                invoiceId: 0,
            };
            shipment.push(obj);
        });
        return shipment;
    }
}
